<!--工时明细-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-form
        style="float: left; padding: 0px 10px 0px 0px"
        :formConfig="formConfig"
        v-model="form"
        :showBtn="false"
        ref="pageForm"
      ></dynamic-form>
      <dynamic-search
        style="float: left"
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
        @reset="reset"
      >
        <template v-slot:next>
          <el-button
icon="el-icon-upload2"
@click="downloadExcel()"
            >导出</el-button
          >
        </template>
      </dynamic-search>

      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{ trigger: 'click', mode: 'cell' }"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        :toolBar="{ hidden: true }"
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #taskState="{ row }">
          <!--任务状态 D待审批，N已分配，Y已完成，T回退 -->
          <el-tag v-if="row.taskState === 'D'">待审批</el-tag>
          <el-tag v-if="row.taskState === 'N'">已分配</el-tag>
          <el-tag v-if="row.taskState === 'Y'">已完成</el-tag>
          <el-tag v-if="row.taskState === 'T'">回退</el-tag>
        </template>
        <template #verifyStatus="{ row }">
          <el-tag v-if="!row.verifyStatus">未确认</el-tag>
          <el-tag v-else>已确认</el-tag>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { parseTime } from "@/utils";
import { downloadExcel } from "@/api/bill/ProjectPlan";
import "@/components/dynamic-form";
import { getDeptTree } from "@/api/dept";
export default {
  name: "ManhourDetails",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin],
  data () {
    return {

      // 默认选中值
      selected: 'A',
      // 数据默认字段
      defaultProps: {
        parent: 'parentId',   // 父级唯一标识
        value: 'id',          // 唯一标识
        label: 'label',       // 标签显示
        children: 'children', // 子级
      },
      form: {},
      treeData: [],
      supThis: this,
      formConfig: {
        formItemList: [
          {
            type: "treeSelect",
            label: "组织",
            key: "deptId",
            width: '220px',
            span: 12,
            props: {
              label: 'name',
              value: 'id',
              children: 'children'
            },
            options: []
          },

        ]
      },
      tableHead: [

        {
          label: "项目名称",
          prop: "projectName",
          width: '120',
          fixed: 'left',
          query: {
            type: "input"
          }
        },
        {
          label: "项目编号",
          prop: "projectCode",
          fixed: 'left',
          width: '120',
          query: {
            type: "input",
            key: 'projectCode'
          }
        },
        {
          label: "用户",
          prop: "userName",
          width: '80',
          fixed: 'left',
          query: {
            type: "input"
          }
        },
        {
          label: "项目经理",
          prop: "projectManageName",
          width: '120'
        },
        {
          label: "终端客户",
          prop: "customerName",
          width: '120',
        },
        {
          label: "任务内容",
          prop: "taskContent",
          width: '120'
        },
        {
          label: "所属部门",
          prop: "deptName",
          width: '100'
        },
        {
          label: "任务时间",
          prop: "plannedStartTime",
          formatter: this.formatter,
          width: '100',
          query: {
            type: "datetimerange",
            key: "plannedStartTime"
          }
        },
        {
          label: "任务分配工时",
          prop: "disposableHumanNature",
          width: '120'
        },
        {
          label: "累计汇报工时",
          prop: "actualHumanNature",
          width: '120'
        },
        {
          label: "实际确认工时",
          prop: "verifyHumanNature",
          width: '120'
        }, {
          label: "计划节点描述",
          prop: "taskNodeDescription",
          width: '120',
          sortable: false
        }, {
          label: "计划节点备注",
          prop: "remark",
          width: '120',
          sortable: false
        }, {
          label: "计划节点成本预估",
          prop: "costEstimation",
          width: '140'
        }, {
          label: "人天单价",
          prop: "settlementPrice",
          width: '100'
        }, {
          label: "任务确认状态",
          prop: "verifyStatus",
          width: '120'
        },
        {
          label: "任务执行状态",
          prop: "taskState",
          slot: "taskState",
          width: '120',
          query: {
            type: 'select',
            data: [{
              label: '待审批',
              value: 'D'
            }, {
              label: '已分配',
              value: 'N'
            }, {
              label: '已完成',
              value: 'Y'
            }, {
              label: '回退',
              value: 'T'
            }]
          }
        },
      ],
    };
  },
  // 任务状态 D待审批，N已分配，Y已完成，T回退
  created () {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
      this.getDeptTreeInterface();
    });
  },
  methods: {
    reset () {
      console.log(111111111);
      this.form.deptId = null
    },
    getDeptTreeInterface () {
      getDeptTree({ loginUser: 'true' }).then(res => {
        // this.treeData = res.data || []
        console.log("resdata")
        this.formConfig.formItemList[0].options = res.data
      });
    },
    formatter (val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    // 导出
    downloadExcel () {
      const query = {
        ...this._query,
        startTime: this._query.plannedStartTime ? this._query.plannedStartTime[0] : '',
        endTime: this._query.plannedStartTime ? this._query.plannedStartTime[1] : '',
        deptId: this.form.deptId || ''
      }
      delete query.plannedStartTime
      downloadExcel('/bizTaskDecomposition/exportWorkTime', query, '工时明细')
    },
    dataTableBeforeInit () {
      this._url = "/bizTaskDecomposition/workTimeDetails";
      const params = { page: this.page, size: this.offset, }
      // const obj = Object.keys(this._query)[0]
      // const obj1 = Object.keys(this._query)[1]
      // const obj2 = Object.keys(this._query)[2]
      // const obj3 = Object.keys(this._query)[3]
      // let start = ''
      // let end = ''
      // console.log(obj,'obj2...',obj2)
      // console.log(this._query[obj2])
      // console.log(this.form.deptId);
      // if (this._query[obj2] && this._query[obj2].length > 0) {
      //   start = this._query[obj2][0]
      //   end = this._query[obj2][1]
      // }
      // const query = { projectName: this._query[obj], userName: this._query[obj1], startTime: start, endTime: end, deptId: this.form.deptId, taskState: this._query[obj3] }
      const _query = {
        ...this._query,
        startTime: this._query.plannedStartTime ? this._query.plannedStartTime[0] : '',
        endTime: this._query.plannedStartTime ? this._query.plannedStartTime[1] : '',
        deptId: this.form.deptId || ''
      }
      delete _query.plannedStartTime
      this._params = Object.assign(params, _query);
      return true;
    },
    dynamicSearch () { },
  }
};
</script>

<style scoped lang="scss">
.el-form-item__content {
  width: 100% !important;
}
</style>
